import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from '@mui/material';
import { primary, secondary } from '../../themes/colors';
import { useTranslation } from 'react-i18next';

const LogoutDialog = ({ open, onClose, onConfirm }) => {
  const { t } = useTranslation();
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 2,
          padding: 1
        }
      }}
    >
      <DialogTitle sx={{ color: primary.main, fontWeight: 500 }}>
        {t('sign_out')}
      </DialogTitle>
      
      <DialogContent>
        <Typography variant="body1">
          {t('sign_out_confirm')}
        </Typography>
      </DialogContent>
      
      <DialogActions sx={{ padding: 2 }}>
        <Button 
          onClick={onClose} 
          color="inherit"
          sx={{ 
            fontWeight: 500,
            textTransform: 'none'
          }}
        >
          {t('cancel')}
        </Button>
        
        <Button 
          onClick={onConfirm} 
          variant="contained"
          sx={{ 
            bgcolor: secondary.main,
            '&:hover': { 
              bgcolor: secondary.dark 
            },
            textTransform: 'none',
            fontWeight: 500
          }}
        >
          {t('sign_out')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogoutDialog;